import moment from 'moment';
import { getNextFundingMonthKey } from './suggestObligations';

export function getPreviousMonthKey(date = moment()) {
  return moment(date).subtract(1, 'month').format('YYYY-MM');
}

let growthInvestmentLineSeq = 0;

export function createGrowthInvestmentLine({
  requestReceivedDate = null,
  fundingMonthKey = '',
  growthInvestment = null,
  marketingSpend = null,
} = {}) {
  growthInvestmentLineSeq += 1;
  return {
    id: `growth-investment-${growthInvestmentLineSeq}`,
    requestReceivedDate,
    fundingMonthKey,
    growthInvestment,
    marketingSpend,
  };
}

export function nextGrowthInvestmentLine(lines) {
  const lastMonthKey = lines?.[lines.length - 1]?.fundingMonthKey;
  return createGrowthInvestmentLine({
    requestReceivedDate: lines?.[0]?.requestReceivedDate ?? null,
    fundingMonthKey: lastMonthKey ? getNextFundingMonthKey(lastMonthKey) : '',
  });
}

export function sumGrowthInvestments(lines) {
  return (lines || []).reduce((sum, line) => {
    const amount = Number(line?.growthInvestment);
    return sum + (Number.isFinite(amount) ? amount : 0);
  }, 0);
}

export function persistedGrowthInvestments(lines) {
  return (lines || []).map((line) => ({
    requestReceivedDate: line.requestReceivedDate || null,
    fundingMonthKey: line.fundingMonthKey || '',
    growthInvestment: line.growthInvestment ?? null,
  }));
}

// Saved invoices may only have the original single growth investment fields.
export function growthInvestmentLinesForDocument(invoice) {
  if (Array.isArray(invoice?.growthInvestments) && invoice.growthInvestments.length > 0) {
    return invoice.growthInvestments.map((line) => ({
      requestReceivedDate: line.requestReceivedDate || invoice.requestReceivedDate || null,
      fundingMonthKey: line.fundingMonthKey || '',
      growthInvestment: line.growthInvestment ?? null,
    }));
  }

  const amount = invoice?.growthInvestment ?? invoice?.purchaseAmount;
  if (invoice?.fundingMonthKey || amount != null) {
    return [
      {
        requestReceivedDate: invoice?.requestReceivedDate || null,
        fundingMonthKey: invoice?.fundingMonthKey || '',
        growthInvestment: amount ?? null,
      },
    ];
  }

  return [];
}
